import {GridWidgetTask} from './grid-widget-task';
export class DataTask extends GridWidgetTask {

  name = 'data-holder';

  dataGetter: () => Array<any>;

  get result(): Array<any> {

    return this.dataGetter();
  }

  updateDataGetter(getter: () => Array<any>): void {
    this.dataGetter = getter;
  }

  getPriority(): number {
    return GridWidgetTask.DATA_TASK_PRIORITY;
  }

  constructor(dataGetter: () => Array<any>) {
    super();
    this.dataGetter = dataGetter;
  }

  run(data: Array<any>): Array<any> {
    return data;
  }
}
